import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';

/**
 * Registro do Service Worker para suporte PWA
 * 
 * O Service Worker é registrado apenas em ambiente de produção
 * Ele permite:
 * - Funcionalidade offline
 * - Cache de recursos estáticos
 * - Melhor performance em carregamentos subsequentes
 * - Suporte para instalação como aplicativo (PWA)
 */
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('Service Worker registrado com escopo:', registration.scope);
      })
      .catch(error => {
        console.error('Falha no registro do Service Worker:', error);
      });
  });
}

/**
 * Inicialização da aplicação React
 * 
 * - ReactDOM.createRoot: API do React 18 para renderização concorrente
 * - App: Componente raiz da aplicação
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
